import {AnalysisLayer} from '../AnalysisLayer';
import {DrawingLayer} from '../DrawingLayer';
import {CadastralLayer} from './CadastralLayer';
import {CurrentPosition} from './CurrentPosition';
import {NearbyFranchiseeLayer} from './NearbyFranchiseeLayer';
import {NearbyInfoLayer} from './NearbyInfoLayer';
import {RulerLayer} from './RulerLayer';
import {StreetView} from './StreetView';

interface IProps {
  map: naver.maps.Map;
}

export const LayerGroup = ({map}: IProps) => {
  if (!map) {
    return null;
  }

  return (
    <>
      <CadastralLayer map={map} />
      <StreetView map={map} />
      <NearbyInfoLayer map={map} />
      <NearbyFranchiseeLayer map={map} />
      <DrawingLayer map={map} />
      <AnalysisLayer map={map} />
      <RulerLayer map={map} />
      <CurrentPosition map={map} />
    </>
  );
};
